export default __webpack_public_path__ + "static/media/edit-pencil.7707dc1d.svg";